import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxCroppieComponent } from './ngx-croppie.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [NgxCroppieComponent],
  exports: [
    NgxCroppieComponent
  ]
})
export class NgxCroppieModule { }
